<template>
  <Layout>
    <GoBack
      class="mb-5"
      text="shottracker news"
      link="Media"
      location="videos"
    />

    <LoadingSpinner v-if="loading.display" :message="loading.message" />

    <div
      v-else
      data-aos="fade-in"
      data-aos-easing="ease-in-out"
      data-aos-duration="500"
    >
      <Title class="mb-5" text="Videos" />

      <div>
        <FeaturedVideo :video="featuredVideo" />

        <div class="inline-block mb-5">
          <Search @search="search" />
        </div>

        <AdminOnly>
          <div
            v-if="listWasUpdated"
            class="inline-block mb-5"
            @click="updatePage"
          >
            <p
              class="
                flex
                rounded-md
                border border-gray-300
                shadow-sm
                px-4
                py-2
                bg-white
                text-md
                font-medium
                text-gray-700
                hover:bg-gray-50
                focus:outline-none
                cursor-pointer
              "
            >
              Update page
            </p>
          </div>

          <draggable
            v-model="videoList"
            group="videos"
            @start="drag = true"
            @end="drag = false"
            class="
              grid
              lg:grid-cols-3
              sm:grid-cols-2
              grid-cols-1
              gap-5
              auto-rows-auto
            "
          >
            <div v-for="video in filterVideos" :key="video.id">
              <EachVideo
                data-aos="fade-in"
                data-aos-easing="ease-in-out"
                data-aos-duration="500"
                :video="video"
                :playVideo="false"
              />
            </div>
          </draggable>
        </AdminOnly>

        <div
          v-if="!isAdmin"
          class="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-5"
        >
          <div v-for="video in filterVideos" :key="video.id">
            <EachVideo
              data-aos="fade-in"
              data-aos-easing="ease-in-out"
              data-aos-duration="500"
              :video="video"
              :playVideo="false"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import EachVideo from './EachVideo.vue'
import Layout from '../../Layout.vue'
import LoadingSpinner from '../../LoadingSpinner.vue'
import FeaturedVideo from './FeaturedVideo.vue'
import GoBack from '../../GoBack.vue'
import Title from '../Title.vue'
import initData from '../../../mixins/initData'
import Search from '../../Search.vue'
import draggable from 'vuedraggable'
import uploadDirectoryToS3 from '../../../api/uploadDirectory'
import AdminOnly from '../../AdminOnly.vue'
import axios from 'axios'

export default {
  name: 'VideosPage',
  mixins: [initData],

  components: {
    EachVideo,
    Layout,
    LoadingSpinner,
    FeaturedVideo,
    GoBack,
    Title,
    Search,
    draggable,
    AdminOnly,
  },

  data() {
    return {
      loading: {
        display: false,
        message: '',
      },
      oldVideoList: [],
      searchInput: '',
      featuredVideo: {},
    }
  },

  computed: {
    ...mapGetters(['directory', 'videosID', 'isAdmin']),

    filterVideos() {
      return this.videoList.filter((video) => {
        const { title } = video
        return title.toLowerCase().includes(this.searchInput.toLowerCase())
      })
    },

    noVideos() {
      return this.videoList.length === 0
    },

    listWasUpdated() {
      return (
        JSON.stringify(this.oldVideoList) !== JSON.stringify(this.videoList)
      )
    },

    videoList: {
      get() {
        return this.directory.videos
      },

      set(value) {
        this.directory.videos = value
      },
    },
  },

  methods: {
    search(text) {
      this.searchInput = text
    },

    async updatePage() {
      this.loading.display = true
      this.loading.message = 'Updating page'

      await uploadDirectoryToS3(this.videoList, 'videos')

      this.loading.display = false

      this.$router.push({
        name: 'Media',
      })
    },
  },

  async created() {
    this.loading.display = true
    this.loading.message = 'Loading videos'

    if (this.noVideos) {
      await this.initData(this.videosID)
    }

    this.oldVideoList = this.directory.videos

    const identifier = this.$route.params.id

    if (identifier == 1) {
      this.featuredVideo = this.videoList[0]
    } else {
      this.featuredVideo = this.oldVideoList.find((video) => {
        return video.id === identifier
      })
    }

    window.scroll({
      top: 0,
      behavior: 'smooth',
    })

    this.loading.display = false
  },
}
</script>
